// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-save-confirmation.MuiModal-root {
  z-index: 11000;
}

.editor-save-confirmation .editor-save-confirmation-backdrop {
  background: var(--overlay-default, rgb(0 0 0 / 45%));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.editor-save-confirmation .editor-save-confirmation-paper {
  width: min(520px, calc(100% - 32px));
  max-height: calc(100% - 32px);
  margin: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 16px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}

.editor-save-confirmation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4, 16px);
  padding: var(--space-5, 20px) var(--space-6, 24px);
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.editor-save-confirmation-header h2 {
  margin: 0;
  font: 600 18px/1.4 var(--font-family-primary, "Lexend", sans-serif);
  color: inherit;
}

.editor-save-confirmation-header button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.editor-save-confirmation-header button:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.editor-save-confirmation-header button:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}

.editor-save-confirmation .editor-save-confirmation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4, 16px);
  padding: var(--space-8, 32px) var(--space-6, 24px);
  text-align: center;
}

.editor-save-confirmation-content .success-checkmark,
.editor-save-confirmation-warning {
  width: 64px;
  height: 64px;
}

.editor-save-confirmation-warning {
  display: grid;
  place-items: center;
  color: var(--warning-text, #7d4412);
  background: var(--warning-soft, #fef8ec);
  border-radius: var(--radius-full, 9999px);
}

.editor-save-confirmation-warning svg {
  width: 28px;
  height: 28px;
}

.editor-save-confirmation-content p {
  margin: 0;
  color: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/components/InlineFeedback/draftSaveConfirmation.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,mEAAmE;EACnE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".editor-save-confirmation.MuiModal-root {\n  z-index: 11000;\n}\n\n.editor-save-confirmation .editor-save-confirmation-backdrop {\n  background: var(--overlay-default, rgb(0 0 0 / 45%));\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.editor-save-confirmation .editor-save-confirmation-paper {\n  width: min(520px, calc(100% - 32px));\n  max-height: calc(100% - 32px);\n  margin: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 16px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.editor-save-confirmation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4, 16px);\n  padding: var(--space-5, 20px) var(--space-6, 24px);\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.editor-save-confirmation-header h2 {\n  margin: 0;\n  font: 600 18px/1.4 var(--font-family-primary, \"Lexend\", sans-serif);\n  color: inherit;\n}\n\n.editor-save-confirmation-header button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.editor-save-confirmation-header button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.editor-save-confirmation-header button:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n\n.editor-save-confirmation .editor-save-confirmation-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-4, 16px);\n  padding: var(--space-8, 32px) var(--space-6, 24px);\n  text-align: center;\n}\n\n.editor-save-confirmation-content .success-checkmark,\n.editor-save-confirmation-warning {\n  width: 64px;\n  height: 64px;\n}\n\n.editor-save-confirmation-warning {\n  display: grid;\n  place-items: center;\n  color: var(--warning-text, #7d4412);\n  background: var(--warning-soft, #fef8ec);\n  border-radius: var(--radius-full, 9999px);\n}\n\n.editor-save-confirmation-warning svg {\n  width: 28px;\n  height: 28px;\n}\n\n.editor-save-confirmation-content p {\n  margin: 0;\n  color: inherit;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
